import { CheckIcon, HandThumbUpIcon, UserIcon } from '@heroicons/react/20/solid'
import { useEffect, useState } from 'react'
import { db } from "../config/firebase";
import { collection, getDocs, onSnapshot, orderBy } from "firebase/firestore";
import { query } from 'firebase/database'
import Message from "./Message";


export default function Product() {
 
const [formulaire, setForms] = useState([]);
const formu = collection(db, "formulaire");

useEffect(() => {
  console.log("Effect ran"); // Ajout d'une instruction console.log pour vérifier si l'effet se déclenche

  const queryMessages = query(formu  ,orderBy("selectedJob"));
  const unsubscribe = onSnapshot(queryMessages, (snapshot) => {
    let formulaire = [];
    snapshot.forEach((doc) => {
      formulaire.push({ ...doc.data(), id: doc.id });
    });
    setForms(formulaire);

    console.log("Forms updated:", formulaire); // Ajout d'une instruction console.log pour vérifier les nouvelles valeurs de `forms`
  });

  return () => {
    console.log("Unsubscribed"); // Ajout d'une instruction console.log pour vérifier si la désinscription se produit
    unsubscribe();
  };
}, []);


  return (
   <div  >
  {formulaire.map((message) => (
  <Message key={message.id} message={message} />
   ))}
            

              </div> 
  )
}
